export default "__VITE_ASSET__e535e657__"